<template>
  <Adminlte>
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="box box-primary center-block">
          <div class="box-header with-border">
            <h3 class="box-title">Adicionar Parceiro</h3>
          </div>
          <PartnerForm :partner="partner" :errors="errors" :onSubmit="onSubmit"></PartnerForm>
        </div>
      </div>
    </div>
  </Adminlte>
</template>
<script>
import Adminlte from '@/components/template/Adminlte'
import PartnerClient from '@/services/resource_client/partner'
import PartnerForm from '@/pages/partners/PartnerForm'

export default {
  name: 'CreatePartner',
  components: { Adminlte, PartnerForm },
  data: function () {
    return {
      partner: {},
      errors: {}
    }
  },
  methods: {
    onSubmit () {
      PartnerClient.post(this.partner)
        .then(r => { this.$router.push({ name: 'Partners' }) })
        .catch(e => { this.errors = e.response.data.errors })
    }
  }
}
</script>



// WEBPACK FOOTER //
// CreatePartner.vue?cb35e884